import "./actions.css";

const Actions = ({clearTilesFromBoard, buttonSize, playedTileCount, turn, play, isMyTurn, playerCount, onExchange, onPass, onChallenge, canChallenge}) => {
    // console.log("Actions props", props)
    const clear = clearTilesFromBoard;

    const statusPrompt = () => {
        if (!isMyTurn) {
            return playerCount === 2 ? "Waiting for your opponent" : "Waiting for your opponents";
        }
        if (playedTileCount) {
            return <span>playing {turn?.words?.[0]} for {turn?.score} points</span>;
        }
        return "Place a tile on board";
    };

    return (
        <>
            <div className="playing text-center">
                {statusPrompt()}
            </div>
            <div className="actions d-flex flex-wrap justify-content-around m-2">
                <button onClick={play} className={`btn btn-${buttonSize} btn-success`} disabled={!isMyTurn || (turn && !turn?.isValid)}>Play</button>
                <button onClick={onPass} className={`btn btn-${buttonSize} btn-warning`} disabled={!isMyTurn}>Pass</button>
                <button onClick={onExchange} className={`btn btn-${buttonSize} btn-primary`} disabled={!isMyTurn || playerCount === 1}>Exchange</button>
                <button onClick={onChallenge} className={`btn btn-${buttonSize} btn-dark`} disabled={!isMyTurn || !canChallenge || playerCount === 1}>Challenge</button>
                <button onClick={clearTilesFromBoard} className={`btn btn-${buttonSize} btn-info`} disabled={!isMyTurn}>Clear</button>
            </div>
        </>
    )
}

export default Actions;